import { Button, Divider, Flex, FormControl, FormLabel, HStack, Heading, IconButton, Input, Select, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { FiArrowLeft } from 'react-icons/fi';
import { addParcelDelivery } from '../../store/actions';
import { parcelDeliveryFromValidation } from '../../utils';
import { parcelDeliveryType } from '../../types';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';

export const AddParcelDelivery = () => {

    const { pickup_points } = useAppSelector(state => state.pickupPointsReducer);

    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const parcelDeliveryForm = useFormik({
        initialValues: {
            first_name: '',
            last_name: '',
            id_number: '',
            email: '',
            phone: '',
            amount: 0,
            status: 'received',
            pickup_address: '',
            dropoff_address: '',
            payment_status: 'unpaid',
            is_customer_location: false,
        },
        validateOnBlur: true,
        validationSchema: parcelDeliveryFromValidation,
        onSubmit: (values: parcelDeliveryType) => {
            parcelDeliveryForm.setSubmitting(true);
            dispatch(addParcelDelivery(values))
                .then(() => navigate('/parcels'))
                .finally(() => parcelDeliveryForm.setSubmitting(false));
        }
    });

    useEffect(() => { }, []);

    return (
        <>
            <Flex
                minH={'-webkit-fill-available'}
                align={'center'}
                justify={'center'}
                pt={2}
                pb={10}
            >
                <Stack bgColor={'white'} borderRadius={6} p={6}>
                    <HStack spacing={6}>
                        <IconButton
                            aria-label={'Go back'}
                            icon={<FiArrowLeft />}
                            onClick={() => navigate('/parcels')}
                        />
                        <Heading size={'md'}>Add Parcel Delivery.</Heading>
                    </HStack>
                    <Divider py={2} />
                    <Stack pt={4}>
                        <form onSubmit={parcelDeliveryForm.handleSubmit}>
                            <SimpleGrid columns={[1, 1, 2, 2, 2]} spacing={4}>
                                <FormControl mb={3} isRequired>
                                    <FormLabel>First name</FormLabel>
                                    <Input
                                        name='first_name'
                                        type='text'
                                        value={parcelDeliveryForm.values.first_name}
                                        onChange={parcelDeliveryForm.handleChange}
                                        onBlur={parcelDeliveryForm.handleBlur}
                                    />
                                    {parcelDeliveryForm.errors.first_name && <Text fontSize='sm' color='red.400'>{parcelDeliveryForm.errors.first_name}</Text>}
                                </FormControl>
                                <FormControl mb={3} isRequired>
                                    <FormLabel>Last name</FormLabel>
                                    <Input
                                        name='last_name'
                                        type='text'
                                        value={parcelDeliveryForm.values.last_name}
                                        onChange={parcelDeliveryForm.handleChange}
                                        onBlur={parcelDeliveryForm.handleBlur}
                                    />
                                    {parcelDeliveryForm.errors.last_name && <Text fontSize='sm' color='red.400'>{parcelDeliveryForm.errors.last_name}</Text>}
                                </FormControl>
                            </SimpleGrid>
                            <SimpleGrid columns={[1, 1, 2, 2, 2]} spacing={4}>
                                <FormControl mb={3}>
                                    <FormLabel>Id number</FormLabel>
                                    <Input
                                        name='id_number'
                                        type='text'
                                        value={parcelDeliveryForm.values.id_number}
                                        onChange={parcelDeliveryForm.handleChange}
                                        onBlur={parcelDeliveryForm.handleBlur}
                                    />
                                    {parcelDeliveryForm.errors.id_number && <Text fontSize='sm' color='red.400'>{parcelDeliveryForm.errors.id_number}</Text>}
                                </FormControl>
                                <FormControl mb={3}>
                                    <FormLabel>Phone</FormLabel>
                                    <Input
                                        name='phone'
                                        type='text'
                                        value={parcelDeliveryForm.values.phone}
                                        onChange={parcelDeliveryForm.handleChange}
                                        onBlur={parcelDeliveryForm.handleBlur}
                                    />
                                    {parcelDeliveryForm.errors.phone && <Text fontSize='sm' color='red.400'>{parcelDeliveryForm.errors.phone}</Text>}
                                </FormControl>
                            </SimpleGrid>
                            <FormControl mb={3} isRequired>
                                <FormLabel>Email</FormLabel>
                                <Input
                                    name='email'
                                    type='email'
                                    value={parcelDeliveryForm.values.email}
                                    onChange={parcelDeliveryForm.handleChange}
                                    onBlur={parcelDeliveryForm.handleBlur}
                                />
                                {parcelDeliveryForm.errors.email && <Text fontSize='sm' color='red.400'>{parcelDeliveryForm.errors.email}</Text>}
                            </FormControl>
                            <SimpleGrid columns={[1, 1, 2, 2, 2]} spacing={4}>
                                <FormControl mb={3}>
                                    <FormLabel>Pickup address</FormLabel>
                                    <Select
                                        name='pickup_address'
                                        placeholder='Select pickup point'
                                        value={parcelDeliveryForm.values.pickup_address}
                                        onChange={parcelDeliveryForm.handleChange}
                                        onBlur={parcelDeliveryForm.handleBlur}
                                    >
                                        {
                                            pickup_points?.map((pickup_point: any, index: number) => <option value={pickup_point?.name} key={index} style={{ textTransform: 'capitalize' }}>{pickup_point?.name}</option>)
                                        }
                                    </Select>
                                    {parcelDeliveryForm.errors.pickup_address && <Text fontSize='sm' color='red.400'>{parcelDeliveryForm.errors.pickup_address}</Text>}
                                </FormControl>
                                <FormControl mb={3}>
                                    <FormLabel>Droppoff address</FormLabel>
                                    <Select
                                        name='dropoff_address'
                                        placeholder='Select droppoff point'
                                        value={parcelDeliveryForm.values.dropoff_address}
                                        onChange={parcelDeliveryForm.handleChange}
                                        onBlur={parcelDeliveryForm.handleBlur}
                                        minW={'300px'}
                                    >
                                        {
                                            pickup_points?.map((pickup_point: any, index: number) => <option value={pickup_point?.name} key={index} style={{ textTransform: 'capitalize' }}>{pickup_point?.name}</option>)
                                        }
                                    </Select>
                                    {parcelDeliveryForm.errors.dropoff_address && <Text fontSize='sm' color='red.400'>{parcelDeliveryForm.errors.dropoff_address}</Text>}
                                </FormControl>
                            </SimpleGrid>
                            <SimpleGrid columns={[1, 1, 2, 2, 2]} spacing={4}>
                                <FormControl mb={3}>
                                    <FormLabel>Amount</FormLabel>
                                    <Input
                                        name='amount'
                                        type='text'
                                        value={parcelDeliveryForm.values.amount}
                                        onChange={parcelDeliveryForm.handleChange}
                                        onBlur={parcelDeliveryForm.handleBlur}
                                    />
                                    {parcelDeliveryForm.errors.amount && <Text fontSize='sm' color='red.400'>{parcelDeliveryForm.errors.amount}</Text>}
                                </FormControl>
                                <FormControl mb={3}>
                                    <FormLabel>Payment status</FormLabel>
                                    <Select
                                        name='payment_status'
                                        placeholder='Select payment status'
                                        value={parcelDeliveryForm.values.payment_status}
                                        onChange={parcelDeliveryForm.handleChange}
                                        onBlur={parcelDeliveryForm.handleBlur}
                                        minW={'300px'}
                                    >
                                        <option value='paid'>Paid</option>
                                        <option value='unpaid'>Unpaid</option>
                                    </Select>
                                    {parcelDeliveryForm.errors.payment_status && <Text fontSize='sm' color='red.400'>{parcelDeliveryForm.errors.payment_status}</Text>}
                                </FormControl>
                            </SimpleGrid>
                            <Stack mt={2}>
                                <Button
                                    colorScheme={'yellow'}
                                    type={'submit'}
                                    isDisabled={parcelDeliveryForm.isSubmitting || !parcelDeliveryForm.isValid}
                                    isLoading={parcelDeliveryForm.isSubmitting}
                                    minW={200}
                                    alignSelf={'flex-end'}
                                >
                                    Submit
                                </Button>
                            </Stack>
                        </form>
                    </Stack>
                </Stack>
            </Flex>
        </>
    );
};